module.exports = __webpack_public_path__ + "a5d419e7869c1c7cc84e1f9682ba11e4.png";